import { Injectable } from '@angular/core';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { API_BASE_URL } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import dbJson from '../../../../db.json';
import routesJson from '../../../../routes.json';

type DbType = typeof dbJson;
type RoutesType = { [pattern: string]: string };

const routes: RoutesType = routesJson as RoutesType;

@Injectable({
  providedIn: 'root',
})
export class AxiosHttpService {
  private axiosInstance: AxiosInstance;

  constructor() {
    // TODO change api url and add Authorization request headers
    this.axiosInstance = axios.create({
      // baseURL: `${API_BASE_URL}/${API_VERSION}`,
      baseURL: `${API_BASE_URL}`,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  // 獲取db.json中數據(模擬API請求) TODO 改為api http請求
  async get<R>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<R>> {
    const db: DbType = dbJson;
    // 根據routes.json中的路由模式匹配db.json中的數據
    let key: keyof DbType | '' = '';
    for (const pattern in routes) {
      const regex = new RegExp('^' + pattern.replace(/\*/g, '.*') + '$');
      if (regex.test(url)) {
        key = routes[pattern].replace(/^\//, '').split('?')[0] as keyof DbType;
        break;
      }
    }
    if (!key) {
      key = url.replace(/^\//, '').split('?')[0] as keyof DbType;
    }
    return Promise.resolve(db[key] as ApiResponse<R>);
  }

  // async get<R>(url: string, config?: AxiosRequestConfig): Promise<ApiResponse<R>> {
  //   const response = await this.axiosInstance.get<ApiResponse<R>>(url, config);
  //   return response.data;
  // }

  async post<T, R>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<R>> {
    const response = await this.axiosInstance.post<ApiResponse<R>>(
      url,
      data,
      config
    );
    return response.data;
  }

  async put<T, R>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<R>> {
    const response = await this.axiosInstance.put<ApiResponse<R>>(
      url,
      data,
      config
    );
    return response.data;
  }

  async delete<R>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<R>> {
    const response = await this.axiosInstance.delete<ApiResponse<R>>(
      url,
      config
    );
    return response.data;
  }
}
